import * as types from './types';

const initialState = {};

function setAllCarrierData(state, action) {
    return {
        ...state,
        ...action.payload,
    };
}

function setCarrierData(state, action) {
    const {
        meta: carrierCode,
        payload: carrierData,
    } = action;

    return {
        ...state,
        [carrierCode]: carrierData,
    };
}

const reducerFunctions = {
    [types.SET_ALL_CARRIER_DATA]: setAllCarrierData,
    [types.SET_CARRIER_DATA]: setCarrierData,
};

function reducer(state = initialState, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}

export default reducer;
